import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';

import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { environment } from '@environment/environment';
import { Header } from '@domain/interface/header';
import { S3_CSV_TEMPLATE } from '@domain/constants/app-variables';
import { IS_EMPTY } from 'cargo-chief-commons';

@Component({
	selector: 'app-first-step',
	templateUrl: './first-step.component.html',
	styleUrls: ['./first-step.component.css'],
})
export class FirstStepComponent implements OnInit {
	@ViewChild('fileInput') fileInput: ElementRef;
	@Input() expectedHeaders: string[];
	@Input() expectedHeadersMap: Header[] = [];
	@Input() dataType: any = null;

	@Output() fileLoadedAndHeadersValidated = new EventEmitter<Object>();
	@Output() fileCleared = new EventEmitter();

	public allLines = [];
	public fileToLoad: File;
	public fileName = '';
	public areHeadersValid = false;

	RFP_UPLOAD_TYPE = 'priceLane';
	PROJECT_TYPE = 'project';
	S3_CSV_TEMPLATE = S3_CSV_TEMPLATE;
	SPECIAL_CHARS_TO_REMOVE = ['�'];

	constructor(private utilService: UtilService) {}

	ngOnInit() {}

	uploadCsvFile($event) {
		this.fileToLoad = $event.target.files[0];
		this.fileName = this.fileToLoad.name;
		let fileReader = new FileReader();

		fileReader.onload = (fileLoadedEvent: any) => {
			let textFromFileLoaded = fileLoadedEvent.target.result;
			let allLines = (this.allLines = this.removeBlankLines(
				textFromFileLoaded.split(/\r\n|\n/)
			).map((line) => {
				this.SPECIAL_CHARS_TO_REMOVE.forEach((chars) => (line = line.replace(chars, '')));
				return line;
			}));

			let headers = allLines[0].split(',');
			let headers2 = allLines[1].split(',')[0];
			if (
				headers2.toString().toLowerCase() == 'required' ||
				headers2.toString().toLowerCase() == 'optional'
			) {
				allLines.splice(1, 1); // remove the required / optional row under the headers from the file. if using the v2 template.
			}
			this.areHeadersValid = this.validateHeaders(headers);
			if (this.dataType == this.RFP_UPLOAD_TYPE && allLines.length > environment.RFP_LANES_LIMIT) {
				this.utilService.showSnackbar(
					`Please limit your file upload to ${environment.RFP_LANES_LIMIT} lanes.`,
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.clearFile();
			}

			if (this.areHeadersValid) {
				this.fileLoadedAndHeadersValidated.emit({
					fileData: this.allLines,
					fileName: this.fileName,
				});
			} else {
				setTimeout(() => {
					this.clearFile();
				});
			}
		};
		fileReader.readAsText(this.fileToLoad, 'UTF-8');
	}

	validateHeaders(headers: string[]): boolean {
		if (
			this.expectedHeadersMap.length > 0 &&
			headers.length < this.expectedHeadersMap.filter((map) => map.required).length
		) {
			setTimeout(() => {
				this.clearFile();
			});
			this.utilService.showSnackbar(
				'Unexpected number of columns. Expected: ' +
					this.expectedHeaders.length +
					' Actual: ' +
					headers.length +
					'.',
				SNACKBAR.ERROR,
				SNACKBAR.ACTION
			);
			return false;
		}
		let trimmedLowerCasedHeaders = [];
		let isValid = true;
		headers.forEach((header) => {
			trimmedLowerCasedHeaders.push(header.toLowerCase().trim());
		});

		isValid = new Set(trimmedLowerCasedHeaders).size === trimmedLowerCasedHeaders.length;
		if (!isValid) {
			this.utilService.showSnackbar(
				'Duplicate headers found. Please check the file and upload again !!',
				SNACKBAR.ERROR,
				SNACKBAR.ACTION
			);
		}
		return isValid;
	}

	clearFile() {
		if (!this.utilService.isNullOrUndefined(this.fileInput)) {
			this.fileInput.nativeElement.value = '';
		}
		this.areHeadersValid = false;
		this.allLines = [];
		this.fileToLoad = null;
		this.fileCleared.emit();
	}

	removeBlankLines(allLines: string[]) {
		let nonBlankLines = [];
		for (let i = 0; i < allLines.length; i++) {
			const line = allLines[i];
			let rowElements = line.split(',');
			if (rowElements.length == 1) {
				continue;
			}
			const emptyFields = rowElements.filter((cellValue) => IS_EMPTY(cellValue));
			if (rowElements.length == emptyFields.length) {
				continue;
			}
			nonBlankLines.push(line);
		}
		return nonBlankLines;
	}
}
